import type AuthenticationType from '@alltrails/types/AuthenticationType';
import type CurrencyCode from '@alltrails/types/CurrencyCode';
import { getPurchaseEventId, getSignupEventId, getTrialStartEventId } from './conversionsApi';

// The AppsFlyer Web SDK exposes a global `AF` queue (see packages/layout/src/scripts/AppsFlyerPBA.tsx).
// Events are recorded via AF('pba', 'event', { eventType, eventName, eventRevenue, eventRevenueCurrency, eventValue }).
// https://support.appsflyer.com/hc/en-us/articles/43485611331473--Beta-Integrate-AppsFlyer-Web-SDK

const isAppsFlyerUnavailable = () => {
  return typeof AF === 'undefined';
};

const setAppsFlyerCustomerUserId = (userId: number) => {
  AF('pba', 'setCustomerUserId', String(userId));
};

export const trackCompleteRegistrationForAppsFlyer = (userId: number, authType: AuthenticationType) => {
  if (isAppsFlyerUnavailable()) {
    return;
  }

  setAppsFlyerCustomerUserId(userId);

  AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'signup',
    eventValue: {
      registration_method: authType,
      event_id: getSignupEventId(userId)
    }
  });
};

export const trackPurchaseForAppsFlyer = ({
  userId,
  currencyCode,
  value,
  isTrial,
  recurlyPlanCode,
  subscriptionEventId
}: {
  userId: number;
  currencyCode: CurrencyCode;
  value: number;
  isTrial: boolean;
  recurlyPlanCode?: string;
  subscriptionEventId?: number;
}) => {
  if (isAppsFlyerUnavailable() || !subscriptionEventId) {
    return;
  }

  setAppsFlyerCustomerUserId(userId);

  if (isTrial) {
    AF('pba', 'event', {
      eventType: 'EVENT',
      eventName: 'start_trial',
      eventRevenueCurrency: currencyCode,
      eventValue: {
        plan_id: recurlyPlanCode,
        event_id: getTrialStartEventId(subscriptionEventId)
      }
    });
  } else {
    AF('pba', 'event', {
      eventType: 'EVENT',
      eventName: 'purchase',
      eventRevenue: value,
      eventRevenueCurrency: currencyCode,
      eventValue: {
        plan_id: recurlyPlanCode,
        event_id: getPurchaseEventId(subscriptionEventId)
      }
    });
  }
};
